import { render, staticRenderFns } from "./GetGDiploma.vue?vue&type=template&id=0ca22a84&scoped=true"
import script from "./GetGDiploma.vue?vue&type=script&lang=js"
export * from "./GetGDiploma.vue?vue&type=script&lang=js"
import style0 from "./GetGDiploma.vue?vue&type=style&index=0&id=0ca22a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca22a84",
  null
  
)

export default component.exports